const MOBILE = window.matchMedia('(max-width: 749px)');

const isActive = (el) => !el.classList.contains('text-truncate--mobile-only') || MOBILE.matches;

const sync = (btn, el) => {
  if (!isActive(el)) {
    btn.hidden = true;
    el.classList.remove('is-expanded');
    return;
  }

  const overflow = el.scrollHeight > el.clientHeight + 2;
  btn.hidden = !overflow;
  if (!overflow) el.classList.remove('is-expanded');
};

const bindToggle = (btn) => {
  const el = btn.previousElementSibling;
  if (!el?.hasAttribute('data-text-truncate-content') || btn.dataset.bound) return;

  btn.dataset.bound = 'true';

  btn.addEventListener('click', (e) => {
    e.preventDefault();
    if (!isActive(el)) return;

    const expanded = el.classList.toggle('is-expanded');
    btn.setAttribute('aria-expanded', String(expanded));
    btn.querySelector('[data-text-truncate-more]').hidden = expanded;
    btn.querySelector('[data-text-truncate-less]').hidden = !expanded;
  });

  requestAnimationFrame(() => requestAnimationFrame(() => sync(btn, el)));
};

const refreshAll = () => {
  document.querySelectorAll('[data-text-truncate-toggle]').forEach((btn) => {
    const el = btn.previousElementSibling;
    if (el?.hasAttribute('data-text-truncate-content')) sync(btn, el);
  });
};

const init = () => document.querySelectorAll('[data-text-truncate-toggle]').forEach(bindToggle);

init();
document.addEventListener('shopify:section:load', init);
MOBILE.addEventListener('change', refreshAll);
window.addEventListener('resize', refreshAll, { passive: true });
